import { ApolloError } from "@apollo/client/core";
import { BRL_CURRENCY_CODE } from "@/core/utilities/brlCurrency";
import { useNotifications } from "@/shared/notification/composables/useNotifications";

export const notifyBrlCurrencyUpdateError = (error: unknown, currency?: string | null): void => {
  if (currency?.toUpperCase() === BRL_CURRENCY_CODE && error instanceof ApolloError) {
    const message = error.graphQLErrors.map(({ message: errorMessage }) => errorMessage).join("\n");
    if (message) {
      useNotifications().error({ text: message });
    }
  }
};
